import { parseRmaError } from 'components/ordering/rma/api/dtos/error.js'


export abstract class RmaRequest<T, E> {
  abstract path: string
  init?: RequestInit
  expectedErrors: readonly number[] = []

  parseResponse?: (json: unknown) => T

  parseError = (status: number, json: unknown) =>
    parseRmaError(status, json) as E
}
